import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/en-ca';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/weekday';
import weekday from 'dayjs/plugin/duration';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import inBetween from 'dayjs/plugin/isBetween';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.extend(weekday);
dayjs.extend(isSameOrBefore);
dayjs.extend(inBetween);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
